import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from './useAnalytics';

export const RouteChangeTracker = () => {
  const location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.trackPageView(location.pathname + location.search);
  }, [location, analytics]);

  return null;
};
